import React from 'react';
import { connect } from 'react-redux';
import { PAGE_TITLES } from 'admin/constants/qr-designer';
import { nextPage, previousPage } from 'admin/actions/qr-designer';
import Button from 'admin/components/shared/Button';
import styles from './styles.scss';

const PageSelector = ({ page, nextPage, previousPage, onSave, canNextPage }) => {
  const list = PAGE_TITLES.map((title, n) => {
    let style;
    if (n < page) {
      style = styles.completed;
    } else if (page === n) {
      style = styles.active;
    } else {
      style = styles.inactive;
    }
    return (<li key={n} className={style}>{title}</li>);
  });

  const last = page === PAGE_TITLES.length - 1;
  const handleClick = last ? onSave : nextPage;
  return (
    <div className={styles.pageSelectorBox}>
      <ol className={styles.pageList}>{list}</ol>
      <div className={styles.transButtons}>
        <Button disabled={page === 0} onClick={previousPage} className={styles.transButton}>戻る</Button>
        <Button disabled={!canNextPage} onClick={handleClick} className={styles.transButton}>{last ? '保存' : '次へ'}</Button>
      </div>
    </div>
  );
}

const mapStateToProps = state => ({
  canNextPage: state.qrDesigner.canNextPage,
});

export default connect(mapStateToProps, {
  nextPage,
  previousPage,
})(PageSelector);
